(function () {
  'use strict';

  var TOTAL_STEPS = 7;
  var STEP_LABELS = ['Identity', 'Current Situation', 'The Crisis', 'What You Need', 'Receiving Funds', 'Documents', 'Attestation'];

  var config = window.emergencyFundingConfig || {};
  var backendUrl = (config.backendUrl || '').replace(/\/$/, '');
  var maxFileSizeBytes = config.maxFileSizeBytes || 20 * 1024 * 1024;
  if (config.stepLabels) STEP_LABELS = config.stepLabels;

  var form = document.getElementById('EFFForm');
  if (!form) return;

  var statusEl = document.getElementById('EFStatus');
  var formWrapper = document.getElementById('EFFormWrapper');
  var progressEl = document.getElementById('EFProgress');
  var backBtn = document.getElementById('EFBack');
  var nextBtn = document.getElementById('EFNext');
  var submitBtn = document.getElementById('EFSubmit');
  var addDocBtn = document.getElementById('EFAddDoc');

  var currentStep = 1;
  var nextAvailableSlot = 3;
  var activeXhrs = [];
  var overlayEl = null;

  // ─────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────
  function init() {
    autoFillDate();
    initCharCounters();
    initFileNameDisplay();
    initConditionals();
    initDocSlots();
    initNav();
    updateNav();
    updateProgress();
  }

  function autoFillDate() {
    var el = document.getElementById('EFF-submission_date');
    if (!el) return;
    var now = new Date();
    var y = now.getFullYear();
    var m = String(now.getMonth() + 1).padStart(2, '0');
    var d = String(now.getDate()).padStart(2, '0');
    el.value = y + '-' + m + '-' + d;
  }

  // ─────────────────────────────────────────
  // CHARACTER COUNTERS
  // ─────────────────────────────────────────
  function initCharCounters() {
    form.querySelectorAll('textarea[data-min-chars]').forEach(function (ta) {
      var countEl = document.getElementById(ta.id + '-count');
      if (!countEl) return;
      updateCharCount(ta, countEl);
      ta.addEventListener('input', function () { updateCharCount(ta, countEl); });
    });
  }

  function updateCharCount(textarea, countEl) {
    var len = textarea.value.length;
    var minChars = parseInt(textarea.getAttribute('data-min-chars') || '0', 10);
    var softCap = parseInt(textarea.getAttribute('data-soft-cap') || '0', 10);
    var currentEl = countEl.querySelector('.ef-char-count__current');
    var minEl = countEl.querySelector('.ef-char-count__min');

    if (currentEl) currentEl.textContent = len;

    countEl.classList.remove('ef-char-count--ok', 'ef-char-count--error', 'ef-char-count--over');

    if (minEl) {
      if (len >= minChars) {
        countEl.classList.add('ef-char-count--ok');
        if (softCap && len > softCap) {
          countEl.classList.add('ef-char-count--over');
          minEl.textContent = 'over recommended ' + softCap + ' characters';
        } else {
          minEl.textContent = softCap ? 'soft cap: ' + softCap : 'minimum met';
        }
      } else {
        minEl.textContent = 'minimum ' + minChars + ' required';
      }
    }
  }

  // ─────────────────────────────────────────
  // FILE NAME DISPLAY
  // ─────────────────────────────────────────
  function initFileNameDisplay() {
    form.querySelectorAll('.ef-file-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        var nameEl = document.getElementById(input.id + '-name');
        if (nameEl) {
          nameEl.textContent = file ? file.name + ' (' + formatSize(file.size) + ')' : '';
        }
        if (file && file.size > maxFileSizeBytes) {
          showStatus('File "' + file.name + '" is too large. Maximum size is ' + Math.round(maxFileSizeBytes / 1024 / 1024) + ' MB.', true);
        }
      });
    });
  }

  // ─────────────────────────────────────────
  // CONDITIONAL FIELDS
  // ─────────────────────────────────────────
  function initConditionals() {
    form.querySelectorAll('[name="is_creative"]').forEach(function (radio) {
      radio.addEventListener('change', updateCreativeField);
    });
    updateCreativeField();

    form.querySelectorAll('[name="request_type"]').forEach(function (radio) {
      radio.addEventListener('change', updateRequestBranch);
    });
    updateRequestBranch();
  }

  function updateCreativeField() {
    var checked = form.querySelector('[name="is_creative"]:checked');
    var group = document.getElementById('EFF-creative_field_group');
    if (!group) return;
    var isYes = checked && checked.value === 'yes';
    toggleConditional(group, isYes);
    var fieldEl = document.getElementById('EFF-creative_field');
    if (fieldEl) {
      fieldEl.required = isYes;
      if (!isYes) fieldEl.value = '';
    }
  }

  function updateRequestBranch() {
    var checked = form.querySelector('[name="request_type"]:checked');
    var val = checked ? checked.value : '';
    var showA = val === 'specific_item' || val === 'both';
    var showB = val === 'general_support' || val === 'both';

    var branchA = document.getElementById('EFF-branch_a');
    var branchB = document.getElementById('EFF-branch_b');

    if (branchA) {
      toggleConditional(branchA, showA);
      var specificItem = document.getElementById('EFF-specific_item');
      var estimatedCost = document.getElementById('EFF-estimated_cost');
      if (specificItem) specificItem.required = showA;
      if (estimatedCost) estimatedCost.required = showA;
    }
    if (branchB) {
      toggleConditional(branchB, showB);
      var supportAmount = document.getElementById('EFF-support_amount');
      var fundUsage = document.getElementById('EFF-fund_usage');
      if (supportAmount) supportAmount.required = showB;
      if (fundUsage) fundUsage.required = showB;
    }
  }

  function toggleConditional(el, show) {
    if (show) {
      el.classList.remove('ef-conditional--hidden');
    } else {
      el.classList.add('ef-conditional--hidden');
    }
  }

  function isInsideHiddenConditional(el) {
    var parent = el.parentElement;
    while (parent && parent !== form) {
      if (parent.classList.contains('ef-conditional--hidden')) return true;
      if (parent.classList.contains('ef-doc-slot--hidden')) return true;
      parent = parent.parentElement;
    }
    return false;
  }

  // ─────────────────────────────────────────
  // DOCUMENT SLOTS
  // ─────────────────────────────────────────
  function initDocSlots() {
    if (addDocBtn) {
      addDocBtn.addEventListener('click', addDocumentSlot);
    }
    form.querySelectorAll('[data-remove-slot]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeDocumentSlot(parseInt(btn.getAttribute('data-remove-slot'), 10));
      });
    });
  }

  function addDocumentSlot() {
    if (nextAvailableSlot > 7) return;
    var slot = document.getElementById('EFDocSlot-' + nextAvailableSlot);
    if (slot) {
      slot.classList.remove('ef-doc-slot--hidden');
      nextAvailableSlot++;
      if (nextAvailableSlot > 7 && addDocBtn) {
        addDocBtn.disabled = true;
        addDocBtn.textContent = 'Maximum documents reached';
      }
    }
  }

  function removeDocumentSlot(slotNum) {
    var slot = document.getElementById('EFDocSlot-' + slotNum);
    if (!slot) return;
    slot.classList.add('ef-doc-slot--hidden');
    slot.querySelectorAll('input, textarea, select').forEach(function (el) {
      if (el.type === 'checkbox' || el.type === 'radio') {
        el.checked = false;
      } else {
        el.value = '';
      }
    });
    var nameEl = document.getElementById('EFF-doc' + slotNum + '_file-name');
    if (nameEl) nameEl.textContent = '';
    if (slotNum < nextAvailableSlot) nextAvailableSlot = slotNum;
    if (addDocBtn) {
      addDocBtn.disabled = false;
      addDocBtn.textContent = '+ Add another document';
    }
  }

  // ─────────────────────────────────────────
  // NAVIGATION
  // ─────────────────────────────────────────
  function initNav() {
    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (backBtn) backBtn.addEventListener('click', goBack);
    form.addEventListener('submit', handleSubmit);
  }

  function goNext() {
    if (!validateStep(currentStep)) return;
    if (currentStep < TOTAL_STEPS) setStep(currentStep + 1);
  }

  function goBack() {
    if (currentStep > 1) {
      hideStatus();
      setStep(currentStep - 1);
    }
  }

  function setStep(step) {
    var currentPanel = document.getElementById('EFStep-' + currentStep);
    if (currentPanel) currentPanel.classList.add('ef-step--hidden');
    currentStep = step;
    var newPanel = document.getElementById('EFStep-' + currentStep);
    if (newPanel) {
      newPanel.classList.remove('ef-step--hidden');
      newPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    updateNav();
    updateProgress();
  }

  function updateNav() {
    var isFirst = currentStep === 1;
    var isLast = currentStep === TOTAL_STEPS;
    var nextLabel = STEP_LABELS[currentStep] ? 'Next: ' + STEP_LABELS[currentStep] : 'Next';

    if (backBtn) backBtn.classList.toggle('ef-nav--hidden', isFirst);
    if (nextBtn) {
      nextBtn.classList.toggle('ef-nav--hidden', isLast);
      if (!isLast) nextBtn.textContent = nextLabel;
    }
    if (submitBtn) submitBtn.classList.toggle('ef-nav--hidden', !isLast);
  }

  function updateProgress() {
    if (!progressEl) return;
    progressEl.querySelectorAll('.ef-progress__item').forEach(function (item) {
      var step = parseInt(item.getAttribute('data-step'), 10);
      item.classList.toggle('ef-progress__item--active', step === currentStep);
      item.classList.toggle('ef-progress__item--done', step < currentStep);
    });
  }

  // ─────────────────────────────────────────
  // VALIDATION
  // ─────────────────────────────────────────
  function validateStep(step) {
    hideStatus();
    var panel = document.getElementById('EFStep-' + step);
    if (!panel) return true;

    var seenRadioGroups = {};
    var allRequired = panel.querySelectorAll('[required]');

    for (var i = 0; i < allRequired.length; i++) {
      var field = allRequired[i];
      if (isInsideHiddenConditional(field)) continue;

      if (field.type === 'radio') {
        if (seenRadioGroups[field.name]) continue;
        seenRadioGroups[field.name] = true;
        var anyChecked = false;
        panel.querySelectorAll('[name="' + field.name + '"]').forEach(function (r) {
          if (r.checked) anyChecked = true;
        });
        if (!anyChecked) {
          showStatus('Please make a selection for: ' + getRadioGroupLabel(field.name, panel), true);
          var fieldset = field.closest('fieldset');
          if (fieldset) fieldset.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return false;
        }

      } else if (field.type === 'checkbox') {
        if (!field.checked) {
          showStatus('Please check all required boxes before continuing.', true);
          field.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return false;
        }

      } else if (field.type === 'file') {
        // File fields in doc slots are validated separately below for steps 6+
        if (step === 6) continue;
        if (!field.files || !field.files[0]) {
          showStatus('Please select a file for: ' + getFieldLabel(field), true);
          field.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return false;
        }
        if (field.files[0].size > maxFileSizeBytes) {
          showStatus('File is too large (max ' + Math.round(maxFileSizeBytes / 1024 / 1024) + ' MB): ' + field.files[0].name, true);
          return false;
        }

      } else {
        var val = field.value.trim();
        if (!val) {
          showStatus('Please fill in: ' + getFieldLabel(field), true);
          field.focus();
          return false;
        }
        if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
          showStatus('Please enter a valid email address.', true);
          field.focus();
          return false;
        }
      }
    }

    // Textarea character minimums (separate loop, post required-field check)
    var textareas = panel.querySelectorAll('textarea[data-min-chars][required]');
    for (var j = 0; j < textareas.length; j++) {
      var ta = textareas[j];
      if (isInsideHiddenConditional(ta)) continue;
      var minChars = parseInt(ta.getAttribute('data-min-chars'), 10);
      if (ta.value.length < minChars) {
        showStatus('Please write at least ' + minChars + ' characters for: ' + getFieldLabel(ta), true);
        ta.focus();
        return false;
      }
    }

    // Step 5: at least one payment option
    if (step === 5) {
      var gofundmeUrl = (document.getElementById('EFF-gofundme_url') || {}).value || '';
      var paymentMethod = (document.getElementById('EFF-payment_method') || {}).value || '';
      var paymentUrl = (document.getElementById('EFF-payment_url') || {}).value || '';
      if (!gofundmeUrl.trim() && (!paymentMethod || !paymentUrl.trim())) {
        showStatus('Please provide either a GoFundMe campaign URL (Option A), or both a payment method and a profile URL (Option B). At least one is required.', true);
        return false;
      }
    }

    // Step 6: document slot validation
    if (step === 6) {
      for (var s = 1; s <= 2; s++) {
        var descEl = document.getElementById('EFF-doc' + s + '_desc');
        var fileEl = document.getElementById('EFF-doc' + s + '_file');
        if (!descEl || !descEl.value.trim()) {
          showStatus('Please provide a description for Document ' + s + '.', true);
          if (descEl) { descEl.focus(); }
          return false;
        }
        if (!fileEl || !fileEl.files || !fileEl.files[0]) {
          showStatus('Please upload a file for Document ' + s + '.', true);
          if (fileEl) fileEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return false;
        }
        if (fileEl.files[0].size > maxFileSizeBytes) {
          showStatus('Document ' + s + ' file is too large. Max ' + Math.round(maxFileSizeBytes / 1024 / 1024) + ' MB.', true);
          return false;
        }
      }
      for (var os = 3; os <= 7; os++) {
        var optSlot = document.getElementById('EFDocSlot-' + os);
        if (!optSlot || optSlot.classList.contains('ef-doc-slot--hidden')) continue;
        var optDesc = document.getElementById('EFF-doc' + os + '_desc');
        var optFile = document.getElementById('EFF-doc' + os + '_file');
        var hasDesc = optDesc && optDesc.value.trim();
        var hasFile = optFile && optFile.files && optFile.files[0];
        if (hasFile && !hasDesc) {
          showStatus('Please add a description for Document ' + os + '.', true);
          if (optDesc) optDesc.focus();
          return false;
        }
        if (hasDesc && !hasFile) {
          showStatus('Please upload a file for Document ' + os + ', or remove the description.', true);
          if (optFile) optFile.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return false;
        }
        if (hasFile && optFile.files[0].size > maxFileSizeBytes) {
          showStatus('Document ' + os + ' file is too large. Max ' + Math.round(maxFileSizeBytes / 1024 / 1024) + ' MB.', true);
          return false;
        }
      }
    }

    return true;
  }

  function getFieldLabel(field) {
    // File inputs use a <p class="ef-file-field__label"> for the visible description
    // rather than the <label for="..."> which just reads "Choose file"
    if (field.type === 'file') {
      var fileField = field.closest('.ef-file-field');
      if (fileField) {
        var descLabel = fileField.querySelector('.ef-file-field__label');
        if (descLabel) return descLabel.textContent.replace(/[\s*\u00a0]+$/, '').trim();
      }
    }
    var label = form.querySelector('label[for="' + field.id + '"]');
    if (label) return label.textContent.replace(/[\s*\u00a0]+$/, '').trim();
    return field.placeholder || field.name || 'this field';
  }

  function getRadioGroupLabel(name, panel) {
    var fieldset = panel.querySelector('fieldset');
    if (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (legend) return legend.textContent.replace(/[\s*]+$/, '').trim();
    }
    return name;
  }

  // ─────────────────────────────────────────
  // STATUS
  // ─────────────────────────────────────────
  function showStatus(message, isError) {
    if (!statusEl) return;
    statusEl.classList.remove('hidden', 'ef-status--success', 'ef-status--error');
    statusEl.classList.add(isError ? 'ef-status--error' : 'ef-status--success');
    statusEl.textContent = (isError ? '\u26A0 ' : '\u2713 ') + message;
    statusEl.setAttribute('tabindex', '-1');
    statusEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    statusEl.focus();
  }

  function hideStatus() {
    if (statusEl) statusEl.classList.add('hidden');
  }

  // ─────────────────────────────────────────
  // UPLOAD OVERLAY
  // ─────────────────────────────────────────
  function buildOverlay(fileItems) {
    if (overlayEl) { overlayEl.remove(); overlayEl = null; }
    overlayEl = document.createElement('div');
    overlayEl.className = 'ef-overlay hidden';
    overlayEl.setAttribute('aria-hidden', 'true');
    overlayEl.setAttribute('role', 'dialog');
    overlayEl.setAttribute('aria-labelledby', 'EFOverlayTitle');

    var content = document.createElement('div');
    content.className = 'ef-overlay__content';

    var title = document.createElement('p');
    title.className = 'ef-overlay__title';
    title.id = 'EFOverlayTitle';
    title.textContent = 'Uploading your files\u2026';
    content.appendChild(title);

    fileItems.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'ef-progress-item';
      row.id = 'EFProgress-' + item.id;
      row.innerHTML =
        '<span class="ef-progress-item__label">' + item.label + '</span>' +
        '<div class="ef-progress-item__bar"><div class="ef-progress-item__fill" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div>' +
        '<span class="ef-progress-item__pct">0%</span>';
      content.appendChild(row);
    });

    var processing = document.createElement('div');
    processing.className = 'ef-overlay__processing hidden';
    processing.id = 'EFOverlayProcessing';
    processing.innerHTML = '<span class="ef-overlay__spinner" aria-hidden="true"></span><span>Submitting application\u2026</span>';
    content.appendChild(processing);

    var cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = 'button button--tertiary ef-overlay__cancel';
    cancelBtn.textContent = 'Cancel';
    cancelBtn.addEventListener('click', function () {
      cancelUploads();
      hideOverlay();
      setSubmitDisabled(false);
      showStatus('Upload cancelled.', true);
    });
    content.appendChild(cancelBtn);

    overlayEl.appendChild(content);
    document.body.appendChild(overlayEl);
  }

  function setProgress(id, percent) {
    if (!overlayEl) return;
    var item = overlayEl.querySelector('#EFProgress-' + id);
    if (!item) return;
    var fill = item.querySelector('.ef-progress-item__fill');
    var pct = item.querySelector('.ef-progress-item__pct');
    if (fill) {
      fill.style.width = Math.min(percent, 100) + '%';
      fill.setAttribute('aria-valuenow', Math.round(percent));
    }
    if (pct) pct.textContent = Math.min(Math.round(percent), 100) + '%';
  }

  function showOverlay() {
    if (overlayEl) {
      overlayEl.classList.remove('hidden');
      overlayEl.setAttribute('aria-hidden', 'false');
    }
  }

  function hideOverlay() {
    if (overlayEl) {
      overlayEl.classList.add('hidden');
      overlayEl.setAttribute('aria-hidden', 'true');
    }
  }

  function showProcessing() {
    if (!overlayEl) return;
    var title = overlayEl.querySelector('#EFOverlayTitle');
    if (title) title.textContent = 'Processing\u2026';
    var proc = overlayEl.querySelector('#EFOverlayProcessing');
    if (proc) proc.classList.remove('hidden');
    var cancel = overlayEl.querySelector('.ef-overlay__cancel');
    if (cancel) cancel.classList.add('hidden');
  }

  function setSubmitDisabled(disabled) {
    if (submitBtn) submitBtn.disabled = disabled;
  }

  // ─────────────────────────────────────────
  // S3 UPLOAD
  // ─────────────────────────────────────────
  function getPresignedUrl(type, filename) {
    var params = new URLSearchParams({ action: 'presign', type: type, filename: filename || 'file' });
    return fetch(backendUrl + '?' + params.toString(), { method: 'GET' }).then(function (res) {
      if (!res.ok) throw new Error('Failed to get upload URL for ' + type);
      return res.json();
    });
  }

  function uploadToS3(file, uploadUrl, progressId) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      activeXhrs.push(xhr);
      xhr.upload.addEventListener('progress', function (e) {
        if (e.lengthComputable) setProgress(progressId, (e.loaded / e.total) * 100);
      });
      xhr.addEventListener('load', function () {
        activeXhrs = activeXhrs.filter(function (x) { return x !== xhr; });
        if (xhr.status >= 200 && xhr.status < 300) resolve();
        else reject(new Error('Upload failed with status ' + xhr.status));
      });
      xhr.addEventListener('error', function () {
        activeXhrs = activeXhrs.filter(function (x) { return x !== xhr; });
        reject(new Error('Upload failed'));
      });
      xhr.addEventListener('abort', function () {
        activeXhrs = activeXhrs.filter(function (x) { return x !== xhr; });
        reject(new Error('Upload cancelled'));
      });
      xhr.open('PUT', uploadUrl);
      xhr.send(file);
    });
  }

  function cancelUploads() {
    activeXhrs.forEach(function (xhr) { xhr.abort(); });
    activeXhrs = [];
  }

  function safeFilename(name) {
    return (name || 'file').replace(/[^a-zA-Z0-9._-]/g, '_').slice(-80) || 'file';
  }

  // ─────────────────────────────────────────
  // SUBMIT
  // ─────────────────────────────────────────
  function handleSubmit(e) {
    e.preventDefault();
    if (!validateStep(TOTAL_STEPS)) return;

    if (!backendUrl) {
      showStatus('Form is not configured. Please set the Backend URL in the theme editor.', true);
      return;
    }

    function fieldVal(id) {
      var el = document.getElementById(id);
      return el ? el.value.trim() : '';
    }
    function radioVal(name) {
      var r = form.querySelector('[name="' + name + '"]:checked');
      return r ? r.value : '';
    }
    function textareaVal(id) {
      var el = document.getElementById(id);
      return el ? el.value : '';
    }

    var textData = {
      full_name:             fieldVal('EFF-full_name'),
      pronouns:              fieldVal('EFF-pronouns'),
      phone:                 fieldVal('EFF-phone'),
      email:                 fieldVal('EFF-email'),
      address_street:        fieldVal('EFF-address_street'),
      address_city:          fieldVal('EFF-address_city'),
      address_state:         fieldVal('EFF-address_state'),
      address_zip:           fieldVal('EFF-address_zip'),
      address_country:       fieldVal('EFF-address_country'),
      address_duration:      fieldVal('EFF-address_duration'),
      employment_status:     fieldVal('EFF-employment_status'),
      profession:            fieldVal('EFF-profession'),
      is_creative:           radioVal('is_creative'),
      creative_field:        fieldVal('EFF-creative_field'),
      housing_status:        fieldVal('EFF-housing_status'),
      tiktok:                fieldVal('EFF-tiktok'),
      instagram:             fieldVal('EFF-instagram'),
      crisis_date:           fieldVal('EFF-crisis_date'),
      crisis_description:    textareaVal('EFF-crisis_description'),
      daily_impact:          textareaVal('EFF-daily_impact'),
      consequences:          textareaVal('EFF-consequences'),
      others_affected:       textareaVal('EFF-others_affected'),
      request_type:          radioVal('request_type'),
      specific_item:         fieldVal('EFF-specific_item'),
      estimated_cost:        fieldVal('EFF-estimated_cost'),
      vendor_name:           fieldVal('EFF-vendor_name'),
      support_amount:        fieldVal('EFF-support_amount'),
      fund_usage:            textareaVal('EFF-fund_usage'),
      gofundme_url:          fieldVal('EFF-gofundme_url'),
      payment_method:        fieldVal('EFF-payment_method'),
      payment_url:           fieldVal('EFF-payment_url'),
      signature:             fieldVal('EFF-signature'),
      submission_date:       fieldVal('EFF-submission_date'),
      website:               fieldVal('EFF-website')
    };

    // Collect files to upload
    var filesToUpload = [];

    function addFile(inputId, type, label) {
      var input = document.getElementById(inputId);
      if (input && input.files && input.files[0]) {
        filesToUpload.push({ file: input.files[0], type: type, id: type, label: label });
      }
    }

    addFile('EFF-photo_id', 'photo_id', 'Photo ID');
    addFile('EFF-selfie', 'selfie', 'Selfie');

    var docMeta = [];
    for (var s = 1; s <= 7; s++) {
      var slotEl = document.getElementById('EFDocSlot-' + s);
      if (s > 2 && (!slotEl || slotEl.classList.contains('ef-doc-slot--hidden'))) continue;
      var docFileInput = document.getElementById('EFF-doc' + s + '_file');
      var docDescInput = document.getElementById('EFF-doc' + s + '_desc');
      var docFile = docFileInput && docFileInput.files && docFileInput.files[0];
      if (!docFile) continue;
      var docType = 'doc_' + s;
      var docDesc = docDescInput ? docDescInput.value.trim() : '';
      filesToUpload.push({ file: docFile, type: docType, id: docType, label: 'Document ' + s });
      docMeta.push({ slot: s, type: docType, description: docDesc });
    }
    textData.documents = docMeta;

    // Build and show overlay
    buildOverlay(filesToUpload);
    setSubmitDisabled(true);
    showOverlay();

    // Upload all files sequentially to avoid rate limiting, then POST
    var uploadResults = [];

    function uploadNext(index) {
      if (index >= filesToUpload.length) return Promise.resolve();
      var item = filesToUpload[index];
      var filename = safeFilename(item.file.name);
      return getPresignedUrl(item.type, filename)
        .then(function (data) {
          return uploadToS3(item.file, data.upload_url, item.id).then(function () {
            setProgress(item.id, 100);
            uploadResults.push({ type: item.type, file_url: data.file_url });
          });
        })
        .then(function () { return uploadNext(index + 1); });
    }

    uploadNext(0)
      .then(function () {
        showProcessing();
        var payload = Object.assign({}, textData, { uploads: uploadResults });
        return fetch(backendUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (res) {
        var contentType = res.headers.get('Content-Type') || '';
        var isJson = contentType.indexOf('application/json') !== -1;
        return (isJson ? res.json() : res.text()).then(function (body) {
          return { ok: res.ok, status: res.status, body: body };
        });
      })
      .then(function (result) {
        hideOverlay();
        if (result.ok) {
          if (formWrapper) formWrapper.classList.add('ef-form-wrapper--hidden');
          if (progressEl) progressEl.classList.add('hidden');
          showStatus('Thank you \u2014 your application has been submitted. Please check your email for further details.', false);
        } else {
          var msg = (result.body && result.body.message) || result.body || 'Submission failed. Please try again.';
          showStatus(typeof msg === 'string' ? msg : 'Submission failed. Please try again.', true);
        }
      })
      .catch(function (err) {
        hideOverlay();
        if (err && err.message === 'Upload cancelled') return;
        showStatus(err && err.message ? err.message : 'Something went wrong. Please try again.', true);
      })
      .finally(function () {
        setSubmitDisabled(false);
      });
  }

  // ─────────────────────────────────────────
  // UTILITIES
  // ─────────────────────────────────────────
  function formatSize(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(1) + ' MB';
    if (bytes >= 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return bytes + ' B';
  }

  // ─────────────────────────────────────────
  // START
  // ─────────────────────────────────────────
  init();
})();
